// Single source of truth for the homepage FAQ — consumed by both the visible
// <FAQ /> section and the FAQPage JSON-LD emitted on the home route, so the two
// can never drift apart. Copy lives in i18n under the `faq.*` keys.

/** Builds the 12 home FAQ Q/A pairs in the active locale from a translator fn. */
export function homeFaqItems(t: (key: string) => string): { q: string; a: string }[] {
  return Array.from({ length: 12 }, (_, i) => ({
    q: t(`faq.q${i + 1}`),
    a: t(`faq.a${i + 1}`),
  }))
}
